import { COLORS } from "../Styles/nodeStyles";

const GroupNode = ({ data }) => {
  const color = data.color || COLORS.ORANGE;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        border: `2px solid ${color}`,
        borderRadius: "8px",
        backgroundColor: "transparent",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "0",
          top: "50%",
          transform: "translate(-50%, -50%) rotate(-90deg)",
          color: color,
          fontFamily: "poppins",
          fontWeight: "600",
          fontSize: "16px",
          backgroundColor: "#ffffff",
          padding: "0 15px",
          whiteSpace: "nowrap",
        }}
      >
        {data.label}
      </div>
    </div>
  );
};

export default GroupNode;
